(() => {
  angular
    .module('app')
    .controller('host.views.hubMessageLog.viewMessage.modal', ViewHubMessageModalController);

  ViewHubMessageModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.hubMessageLog',
    'logId',
  ];

  function ViewHubMessageModalController($uibModalInstance, hubMessageLogSvc, logId) {
    const vm = this;
    vm.loading = 0;
    vm.log = null;

    vm.cancel = () => {
      $uibModalInstance.dismiss();
    };

    // Pretty-print stored JSON for the operator; fall back to the raw string when the
    // payload is not valid JSON.

    vm.pretty = (text) => {
      if (!text) return '';
      try {
        return JSON.stringify(JSON.parse(text), null, 2);
      } catch (e) {
        return text;
      }
    };

    init();

    function init() {
      vm.loading += 1;
      hubMessageLogSvc
        .getHubMessageLog({ id: logId })
        .success((data) => {
          vm.log = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
